import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
export const DebugPanelFrame = (props) => {
    const [showPanel, setShowPanel] = useState(false);
    if (process.env.NODE_ENV !== 'development')
        return null;
    const toggleShow = () => {
        setShowPanel(!showPanel);
    };
    return (_jsx(_Fragment, { children: _jsxs("div", { style: {
                zIndex: '1',
                position: 'fixed',
                right: '0px',
                bottom: '0px',
                display: 'flex',
            }, children: [_jsx("div", { style: {
                        alignSelf: 'flex-end',
                        fontWeight: 'bold',
                        color: '#ffffff',
                        backgroundColor: '#228866',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '2em',
                        height: '5em',
                        writingMode: 'sideways-lr',
                        borderTopLeftRadius: '10px',
                        cursor: 'pointer',
                    }, onClick: toggleShow, children: "Debug" }), _jsx("div", { style: {
                        display: showPanel ? 'block' : 'none',
                        backgroundColor: '#bbffdd',
                        height: 'auto',
                        width: 'auto',
                        border: '5px solid #228866',
                        borderTopLeftRadius: '20px',
                        padding: '8px',
                        overflow: 'hidden'
                    }, children: props.children })] }) }));
};
